// level is optional
const isValidPlanName = (planName: string) => {
  const regex =
    /(training|taper|taperExtended)plan(-|_)((0?[1-9]|[1-4][0-9]|5[0-2])w_)?(recovery(-|_))?(5km|10km|20mi|halfmarathon|marathon|coopah_preparation|ultra_preparation|ultra_50km|ultra_100km|half marathon|coopah preparation|ultra preparation|ultra 50km|ultra 100km|strength_and_conditioning)(_| |-)?((level1|level2|level3|level4))?((-All )?(L1|L2|L3|L4))?.csv/i
  return regex.test(planName)
}
// supports both trainingplan_20w_marathon_level1.csv and trainingplan_20w_marathon-All L1.csv, also support taperplan_1w_5km-All L2.csv
export default isValidPlanName
